import LandingHeader from "../components/LandingHeader";
import styles from "./page.module.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../AuthConfig";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../store/authSlice";
import ContentCard from "../components/ContentCard";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import { useEffect } from "react";

export default function LandingPage() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mode } = useTheme();
  const { isAuthenticated, inProgress } = useAuth();

  // Redirect to /chat if authenticated (fires after login)
  useEffect(() => {
    if (isAuthenticated && inProgress !== "login") {
      navigate("/chat", { replace: true });
    }
  }, [isAuthenticated, inProgress, navigate]);

  // If not authenticated and not in progress, trigger login immediately
  useEffect(() => {
    if (!isAuthenticated && inProgress === "none") {
      instance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, inProgress, instance]);

  // Prevent rendering if redirecting or logging in
  if ((isAuthenticated && inProgress === "none") || (!isAuthenticated && inProgress === "none")) {
    return null;
  }

  const handleLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);
      if (response.account) {
        instance.setActiveAccount(response.account);
        dispatch(setUser(response.account));
        navigate("/chat"); // redirect after login
      }
    } catch (error) {
      // Login failed - error will be handled by MSAL
    }
  };
  // Prevent rendering if redirecting or logging in
  if (inProgress === "none" && (!isAuthenticated)) {
    return null;
  }

  return (
    // <div className={styles.ladningPageContainer}>
    //   <LandingHeader
    //     logoUrl={`${mode === "dark" ? "images/logo_white.svg" : "images/logo.svg"}`}
    //     onLogin={handleLogin}
    //   />
    //   <div className={styles.landingMainContent}>
    //     <div className={styles.landingTextContent}>
    //       <ContentCard
    //         title="Portfolio Insights Agent"
    //         imageUrl={`${mode === "dark" ? "images/logo_white.svg" : "images/logo.svg"}`}
    //         subTitle="GPPM AI Assistant that answers questions, provides insights, and
    //           supports analysis on the Astrazeneca drug Portfolio"
    //         description="Created by AZ GPPM Platforms Team"
    //       />
    //     </div>
    //   </div>
    // </div>
    <div></div>
  );
}
